import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [agency, setAgency] = useState(null);
  const [permissions, setPermissions] = useState([]);
  // Les options du plan (25/09) : l'interface masque ce que le plan ne comprend pas.
  const [features, setFeatures] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session is an httpOnly cookie — just ask the backend who we are.
    api.get('/auth/me')
      .then(({ data }) => {
        setUser(data.user);
        setAgency(data.agency);
        setPermissions(data.permissions || []);
        setFeatures(data.features || null);
        setIsSuperAdmin(!!data.is_super_admin);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const applySession = async (data) => {
    setUser(data.user);
    setAgency(data.agency);
    const me = await api.get('/auth/me');
    setPermissions(me.data.permissions || []);
    setFeatures(me.data.features || null);
    setIsSuperAdmin(!!me.data.is_super_admin);
  };

  const login = async (email, password, turnstileToken) => {
    const { data } = await api.post('/auth/login', { email, password, turnstile_token: turnstileToken || undefined });
    await applySession(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    await applySession(data);
    return data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch { /* cookie may already be gone */ }
    setUser(null);
    setAgency(null);
    setPermissions([]);
    setFeatures(null);
    setIsSuperAdmin(false);
  };

  const hasPerm = (p) => !p || permissions.includes(p);
  // Tant que /auth/me n'a pas repondu (features === null), on ne cache RIEN :
  // un ecran qui disparait une seconde au chargement serait pire que tout.
  const hasFeature = (f) => !f || features === null || features.includes(f);

  return (
    <AuthContext.Provider value={{ user, agency, permissions, features, isSuperAdmin, loading, login, register, logout, hasPerm, hasFeature, setUser, setAgency }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
